import React from 'react';
import { CircularProgress } from '@mui/material';

export const CircularProgressContainer = props => {
  const { size, thickness } = props;

  return (
    <CircularProgress
      sx={{
        position: 'absolute',
        left: 0,
        right: 0,
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '20%',
        zIndex: 1
      }}
      thickness={thickness || 4.5}
      size={size || 100}
      variant="indeterminate"
      disableShrink={true}
    />
  );
};
